import React, { Component } from 'react';
import Chart_Pie from '../../../Part_Sample/Chart_Pie';
import { isEmpty } from '../../../Common/Common';

export default class Categories_Pie_Charts extends Component {
	constructor(props) {
		super(props);
		this.is_show_categories = false;
		this.energy_category_ids = [];
		let report_settings = this.props.report_settings;

		if (!isEmpty(report_settings)) {
			if (!isEmpty(report_settings.categories)) {
				if (report_settings.categories.is_show_energy_categories) {
					this.is_show_categories = true;
					for (let id in report_settings.categories.energy) {
						if (report_settings.categories.energy[id].is_enabled) {
							this.energy_category_ids.push(id);
						}
					}
				}
			}
		}

		this.state = {

		}

		this.hour_chart = React.createRef();
		this.today_chart = React.createRef();
		this.month_chart = React.createRef();
	}

	refreshChart = () => {
		this.hour_chart.current.loadChart();
		this.today_chart.current.loadChart();
		this.hour_chart.current.loadChart();
	}

	getTotalByCategories = (type) => {
		let data = [];
		let report_settings = this.props.report_settings;

		for (let energy_id of this.energy_category_ids) {
			if (!isEmpty(this.props.data[energy_id])) {
				let row = [];
				row.push(report_settings.categories.energy[energy_id].name);
				row.push(this.props.data[energy_id][type]);
				data.push(row);
			} else {
				// If no data
				let row = [];
				row.push(report_settings.categories.energy[energy_id].name);
				row.push(0);
				data.push(row);
			}
		}

		return data;
	}

	getTotal = (type) => {
		let data = [];

		for (let id in this.props.data) {
			if (!isEmpty(window.app.state.point_list[id])) {
				let point_info = window.app.state.point_list[id];
				if (point_info.usage == 'emeter') {
					let row = [];
					row.push(point_info.name);
					row.push(this.props.data[id][type]);
					data.push(row);
				}
			}
		}

		return data
	}

	render() {
		let hour_data = [];
		let day_data = [];
		let month_data = [];
		let report_settings = this.props.report_settings;
		if (this.is_show_categories) {
			hour_data = this.getTotalByCategories('hour');
			day_data = this.getTotalByCategories('day');
			month_data = this.getTotalByCategories('month');
		} else {
			hour_data = this.getTotal('hour');
			day_data = this.getTotal('day');
			month_data = this.getTotal('month');
		}

		let chart_width = (this.props.width - 40) / 3;
		let chart_height = chart_width * 2;

		let is_landscape = (this.props.width >= this.props.height)
		if (is_landscape) {
			chart_height = this.props.width / 3;
			if (chart_height > this.props.height - 240 && chart_height > 250) chart_height = this.props.height - 240;
		}

		return (
			<div>
				<div style={{ display: 'inline-block' }}>
					<Chart_Pie
						id="this_hour"
						ref={this.hour_chart}
						chart_width={chart_width}
						chart_height={chart_height}
						data={hour_data}
						title={this.props.receiver.getString('this_hour')}
					/>
				</div>
				<div style={{ display: 'inline-block', marginRight: 10 }}>
					<Chart_Pie
						id="today"
						ref={this.today_chart}
						chart_width={chart_width}
						chart_height={chart_height}
						data={day_data}
						title={this.props.receiver.getString('today')}
					/>
				</div>
				<div style={{ display: 'inline-block', marginRight: 10 }}>
					<Chart_Pie
						id="this_month"
						ref={this.month_chart}
						chart_width={chart_width}
						chart_height={chart_height}
						data={month_data}
						title={this.props.receiver.getString('this_month')}
					/>
				</div>

			</div>
		)
	}
}